import React from 'react'

export default function Mission() {
    return (
        <section className="solve-section pt-100 pb-70">
        <div className="container">
            <div className="section-title">
                <span>
                    <i className="flaticon-to-do-list"></i>
                    What We Do
                </span>
                <h2>A mission to solve a problem</h2>
                <p>We take the responsibility of providing a better life to orphans, refugee children and children from poor families that have no hope for the future otherwise into their hands. We provide;</p>
            </div>

            <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="solve-item-two">
                        <div className="icon">
                            <img src="assets/img/solve/1.png" alt="Solve-1"/>
                        </div>
                        <h3>Education Facilities</h3>
                        <p>Education is our biggest tool, and we use it to empower the future generation. We continue to provide education services at our facility.</p>
                        <br/>
                        <br/>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="solve-item-two">
                        <div className="icon">
                            <img src="assets/img/solve/2.png" alt="Solve-2"/>
                        </div>
                        <h3>Medical Facilities</h3>
                        <p>In line with our goal to cater to the well-being of the children under our care, we continue to provide them with suitable health care services.</p>
                        <br/>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="solve-item-two">
                        <div className="icon">
                            <img src="assets/img/solve/3.png" alt="Solve-3"/>
                        </div>
                        <h3>Healthy Food</h3>
                        <p>We are on a quest to eradicate malnutrition. We ensure that our children receive three meals daily in accordance to the national food guide.</p>
                        <br/>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="solve-item-two">
                        <div className="icon">
                            <img src="assets/img/solve/4.png" alt="Solve-4"/>
                        </div>
                        <h3>Pure Water</h3>
                        <p>We also ensure pure, clean drinking water delivery to our children. This is done to complete the balanced diet in order to combat  malnutrition among orphans and refugee children.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}
